import { Outlet } from "react-router-dom";

export const Authentication = () => (
  <div className="T-Authentication">
    <Outlet />
  </div>
);
